import { TextField, Typography, Button, Stack } from "@mui/material";
import { useState } from "react";
import PasswordImage from "assets/password.png";
import InfoIcon from "@mui/icons-material/Info";
import ModalFindCode from "./ModalFindCode/ModalFindCode";
import { useContext } from "react";
import ApiContext from "api";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { AuthService } from "context/AuthContext/AuthContext";

export default function LoginStepClientCode({ segment, cpfCnpj, cpfAccess }) {
  const [openModalInfo, setOpenModalInfo] = useState(false);
  const [clientCode, setClientCode] = useState("");

  const { ConsigazApi } = useContext(ApiContext);

  const router = useHistory();

  const featureFlagNovaFormaAcessoContaSim = process.env.REACT_APP_FLAG_NOVA_FORMA_ACESSO_CONTASIM === "true";
  const featureFlagNovaFormaAcessoIndustrial = process.env.REACT_APP_FLAG_NOVA_FORMA_ACESSO_INDUSTRIAL === "true";
  const featureFlagNovaFormaAcesso = ((segment === "CONTASIM" && featureFlagNovaFormaAcessoContaSim) || featureFlagNovaFormaAcessoIndustrial);

  const handleSubmit = async () => {
    if (!clientCode.trim()) {
      return toast.error("Código de cliente é obrigatório.");
    }

    try {
      if (featureFlagNovaFormaAcesso) {
        const response = await ConsigazApi.validateClientCode(
          cpfCnpj,
          clientCode
        );

        if (response.RetornoCliente[0]["status-retorno"] === "Não") {
          return toast.error("Código de cliente inválido.");
        }

        const path =
          (segment === "CONTASIM") ? "/register-client" : "/register-industrial";

        return router.push({
          pathname: path,
            state: {
              cpfCnpj,
              existentClient: segment === "CONTASIM" ? true : false,
              clientCode,
              cpfAccess,
            },
          });
      } else {
        const { Cliente } = await ConsigazApi.consultaLocalEntrega(cpfCnpj);

        if (Cliente?.ClienteRetorno[0]["cod-emitente"] == clientCode) {
          if (segment === "CONTASIM") {
            AuthService.setTokenLocalStorage("Zm9vOmJhcgo=");
            AuthService.setUserCpfLocalStorage(cpfCnpj);
          }

          return router.push({
            pathname: segment === "CONTASIM" ? "/existent-client" : "/new-industrial-client",
            state: segment === "CONTASIM" ? { cliente: Cliente.ClienteRetorno[0] } : { industrialClientInfos: { cliente: Cliente.ClienteRetorno[0] } },
          });
        } else {
          return toast.error("Código de cliente inválido.");
        }
      }

    } catch (error) {
      console.error("Error submitting client code:", error);
    }
  };

  return (
    <>
      <img src={PasswordImage} />
      <Typography
        color="#FFFFFF"
        fontWeight={700}
        fontSize={"30px"}
        mt={"30px"}
      >
        {featureFlagNovaFormaAcesso ?
            "Olá, novamente!"
            :
            "Só mais um passo!"
        }
      </Typography>
      <Typography
        color="#FFFFFF"
        fontSize={"15px"}
        mt={"10px"}
        textAlign={"justify"}
      >
        {featureFlagNovaFormaAcesso ?
          "A partir de agora, o acesso ao portal Consigaz será feito com a senha \
          pessoal personalizada do usuário."
          :
          "Insira o Código do Cliente de um dos seus imóveis e carregaremos todos os seus registros no aplicativo."
        }
      </Typography>

      <Typography
        color="#FFFFFF"
        fontSize={"15px"}
        mt={"15px"}
        textAlign={"justify"}
      >
        {featureFlagNovaFormaAcesso ?
          "Para cadastrar sua senha, vamos utilizar seu código de cliente. No seu \
          próximo acesso ao aplicativo, será solicitado apenas sua senha nova. \
          Para começar seu cadastro, por favor, insira seu código de cliente:" : ""
        }
      </Typography>

      <TextField
        variant="standard"
        color="secondary"
        value={clientCode}
        type="number"
        fullWidth
        onChange={(e) => {
          setClientCode(e.target.value);
        }}
        placeholder={"Código do cliente"}
        sx={{
          mt: 5,
          "& input::-webkit-inner-spin-button": {
            WebkitAppearance: "none",
          },
        }}
      />
      <Button
        variant="contained"
        color="secondary"
        sx={{
          height: "45px",
          color: "#fff",
          borderRadius: "36px",
          width: "100%",
          mt: 2,
        }}
        onClick={handleSubmit}
      >
        Avançar
      </Button>

      <Stack
        direction={"row"}
        justifyContent={"center"}
        alignItems={"center"}
        mt={2}
        mb={12}
        gap={1}
        sx={{
          cursor: "pointer",
        }}
      >
        <InfoIcon
          sx={{
            color: "#2894f7",
          }}
        />
        <Typography
          color="#2CABF9"
          fontWeight={600}
          fontSize={"15px"}
          sx={{
            zIndex: 1000,
          }}
          onClick={() => setOpenModalInfo(true)}
        >
          Encontrar meu código de cliente
        </Typography>
      </Stack>
      <ModalFindCode
        open={openModalInfo}
        onClose={() => setOpenModalInfo(false)}
      />
    </>
  );
}
